import { type MCPServerInfo } from '../../types';

const SlackCommunityServer: MCPServerInfo = {
  serverId: 'SLACK_COMMUNITY',
  name: 'Slack (Natoma)',
  slug: 'slack-community',
  description: 'Slack Community MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'mcp/slack-mcp-server-next:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default SlackCommunityServer;
